import Component from '@glimmer/component';

/**
 * The ConditionalRenderer component in Ember offers conditional rendering based on
 * the value of @row.columnValue.component. This component dynamically renders
 * different UI elements based on specific conditions:

 * Condition 1: Link Rendering
 * If @row.columnValue.component equals 'link', it renders a LinkTo component.
  Attributes like @route, @model, and test-id are populated from @value.
  Displays the label (@value.label) as the link text.


 * Condition 2: Button Rendering
 * If @row.columnValue.component equals 'button', it renders a <button> element.
  Attributes such as test-id, class, and an onClick action may be defined.
  Displays the label (@value.label) as the button text.


 * Condition 3: Custom Component Rendering
 * If the value is neither 'link' nor 'button', it assumes the value represents a custom component string.
   Dynamically renders the specified custom component with @value as its parameters.

 */
export default class TableV2DynamicCellIndexComponent extends Component {
  get onClick() {
    return this.args?.value?.onClick ?? function () {};
  }

  get class() {
    switch (this.args.row.columnValue?.type) {
      case 'primary':
        return 'text-indigo-600';
      case 'secondary':
        return 'text-gray-900';
      case 'danger':
        return 'text-red-600';
      default:
        return '';
    }
  }
}
